import VueCharts from 'vue-chartjs'
export default {
    extends: VueCharts.Bar,
    data: () => ({
        labels: [],
        totalCandidates: [],
        totalMarked: [],
        totalCertified: [],
    }),
    mounted() {
        var self = this
        self.$ajax.get('/GRAD_CANDIDATES/GetSelectedStudentsProgressAsync').then(response => {

            for (var i = 0; i < response.data.length; i++) {
                self.labels.push(response.data[i].REGION_NAME)
                self.totalCandidates.push(response.data[i].TOTAL_CANDIDATES)
                self.totalMarked.push(response.data[i].TOTAL_MARKED)
                self.totalCertified.push(response.data[i].TOTAL_CERTIFIED)
            }

            self.renderChart({
                labels: self.labels,
                datasets: [
                    {
                        label: 'Cantidatos Graduación',
                        backgroundColor: '#e6b400',
                        data: self.totalCandidates
                    },
                    {
                        label: 'Marcados No Certificados',
                        backgroundColor: '#dce775',
                        data: self.totalMarked
                    },
                    {
                        label: 'Certificados',
                        backgroundColor: '#e65a3b',
                        data: self.totalCertified
                    }
                ]
            }, {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    responsive: true,
                    responsiveAnimationDuration: 1000,
                    maintainAspectRatio: false
                })
        }).catch(response => {
            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/graduados/reportes/estudiantesSeleccionados.js